module.exports = __webpack_public_path__ + "static/media/Benefit Highlights with Cover HMO.239eb73e.pdf";